/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Starter_Challenge_Phase_2_DescriptionInputs */

const en_starter_challenge_phase_2_description = /** @type {(inputs: Starter_Challenge_Phase_2_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stay steady through distractions, explore deep focus mode, and make your focus more stable and complete.`)
};

const ar_starter_challenge_phase_2_description = /** @type {(inputs: Starter_Challenge_Phase_2_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ابقَى ثابتًا رغم المشتتات، جرّب وضع التركيز العميق، واجعل تركيزك أكثر ثباتًا واكتمالًا.`)
};

const de_starter_challenge_phase_2_description = /** @type {(inputs: Starter_Challenge_Phase_2_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bleiben Sie bei Ablenkungen ruhig, erkunden Sie den Tiefenfokusmodus und machen Sie Ihren Fokus stabiler und vollständiger.`)
};

const es_starter_challenge_phase_2_description = /** @type {(inputs: Starter_Challenge_Phase_2_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mantente estable frente a las distracciones, explora el modo de concentración profunda y haz que tu enfoque sea más sostenido y completo.`)
};

const fr_starter_challenge_phase_2_description = /** @type {(inputs: Starter_Challenge_Phase_2_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gardez le cap face aux distractions, découvrez le mode Concentration Profonde, et cultivez une concentration plus stable et épanouie.`)
};

const it_starter_challenge_phase_2_description = /** @type {(inputs: Starter_Challenge_Phase_2_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mantieni la stabilità nonostante le distrazioni, esplora la modalità di Concentrazione intensiva e rendi la tua attenzione più stabile e completa.`)
};

const ja_starter_challenge_phase_2_description = /** @type {(inputs: Starter_Challenge_Phase_2_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`気を散らすものに惑わされず、ディープモードを活用して、集中をより安定して充実したものにしましょう。`)
};

const ko_starter_challenge_phase_2_description = /** @type {(inputs: Starter_Challenge_Phase_2_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`산만함 속에서도 흔들리지 않고 초집중 모드를 탐색하며 더 안정적이고 완전하게 집중하세요.`)
};

const pt_br_starter_challenge_phase_2_description = /** @type {(inputs: Starter_Challenge_Phase_2_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mantenha a consistência em meio às distrações, explore o modo Foco Total, e torne seu foco mais estável e completo.`)
};

const ru_starter_challenge_phase_2_description = /** @type {(inputs: Starter_Challenge_Phase_2_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохраняйте устойчивость при отвлекающих факторах, изучите режим глубокой фокусировки и сделайте свою сосредоточенность более стабильной и полной.`)
};

const th_starter_challenge_phase_2_description = /** @type {(inputs: Starter_Challenge_Phase_2_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รักษาความมั่นคงท่ามกลางสิ่งรบกวน สำรวจโหมดโฟกัสเต็มที่ และทำให้การโฟกัสของคุณเสถียรและสมบูรณ์ยิ่งขึ้น`)
};

const tr_starter_challenge_phase_2_description = /** @type {(inputs: Starter_Challenge_Phase_2_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dikkat dağıtıcı unsurlara rağmen istikrarlı kal, derin odaklanma modunu keşfet ve odaklanmanı daha istikrarlı ve eksiksiz hale getir.`)
};

const zh_cn_starter_challenge_phase_2_description = /** @type {(inputs: Starter_Challenge_Phase_2_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在干扰中保持专注、探索深度模式，让你的专注更稳定、更全面。`)
};

const zh_tw_starter_challenge_phase_2_description = /** @type {(inputs: Starter_Challenge_Phase_2_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在干擾中保持專注、探索深度模式，讓你的專注更穩定、更全面。`)
};

/**
* | output |
* | --- |
* | "Stay steady through distractions, explore deep focus mode, and make your focus more stable and complete." |
*
* @param {Starter_Challenge_Phase_2_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const starter_challenge_phase_2_description = /** @type {((inputs?: Starter_Challenge_Phase_2_DescriptionInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Starter_Challenge_Phase_2_DescriptionInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_starter_challenge_phase_2_description(inputs)
	if (locale === "ar") return ar_starter_challenge_phase_2_description(inputs)
	if (locale === "de") return de_starter_challenge_phase_2_description(inputs)
	if (locale === "es") return es_starter_challenge_phase_2_description(inputs)
	if (locale === "fr") return fr_starter_challenge_phase_2_description(inputs)
	if (locale === "it") return it_starter_challenge_phase_2_description(inputs)
	if (locale === "ja") return ja_starter_challenge_phase_2_description(inputs)
	if (locale === "ko") return ko_starter_challenge_phase_2_description(inputs)
	if (locale === "pt_br") return pt_br_starter_challenge_phase_2_description(inputs)
	if (locale === "ru") return ru_starter_challenge_phase_2_description(inputs)
	if (locale === "th") return th_starter_challenge_phase_2_description(inputs)
	if (locale === "tr") return tr_starter_challenge_phase_2_description(inputs)
	if (locale === "zh_cn") return zh_cn_starter_challenge_phase_2_description(inputs)
	return zh_tw_starter_challenge_phase_2_description(inputs)
});